import Sortable from "sortablejs";

export function adminTagGroups(args) {
  const { creating, options, hasOrderChanged } = args;
  return {
    creating,
    options,
    hasOrderChanged,
    init() {
      const sortableList = document.getElementById("sortable-list");
      const self = this;
      if (!sortableList) return;

      new Sortable(sortableList, {
        animation: 150,
        handle: ".handle",
        preventOnFilter: false,
        onEnd: function () {
          const items = Array.from(
            sortableList.querySelectorAll("[data-sortable-item]"),
          );
          const order = items.map((item) => item.dataset.tagId);

          // Update the hidden input with the new order
          self.$refs.tagOrder.value = order.join(",");
          self.hasOrderChanged = true;
        },
      });
    },
  };
}
